// removed by extract-text-webpack-plugin
module.exports = {"navWrapper":"DesignToolBar__navWrapper"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DesignToolBar/DesignToolBar.scss
// module id = ./src/components/DesignToolBar/DesignToolBar.scss
// module chunks = 2